import { useState } from "react";
import {
  FilterOptionProps,
  MapFilterTitle,
  MapSidebarFiltersProps,
} from "../../mapSidebar/mapSidebarFilters/mapSidebarFilters";
import { countryFilterOptions } from "../configData";

export type SidebarProps = {
  defaultDateRange?: string;
  defaultDropdownKey: string;
  availableTypes: string[];
};
export type ReportingMapFilters = Omit<
  MapSidebarFiltersProps,
  "dashboardMode" | "toggleDashboardMode"
>;
type CountryFilterProps = {
  countryFilter: {
    [key: string]: boolean;
  };
  setCountryFilter: React.Dispatch<
    React.SetStateAction<{
      [key: string]: boolean;
    }>
  >;
};

type ReportingMapFiltersHook = (
  sidebarProps: SidebarProps
) => ReportingMapFilters & CountryFilterProps;

const useReportingMapFilters: ReportingMapFiltersHook = (sidebarProps) => {
  const filterOptions = generateFilterOptionsFromSidebarProps(sidebarProps);

  const [countryFilter, setCountryFilter] = useState(countryFilterOptions);
  const [currentFilters, setCurrentFilters] = useState(
    generateDefaultFiltersFromFilterOptions(filterOptions)
  );

  const onFiltersChange = (title: MapFilterTitle, value: string) => {
    setCurrentFilters({
      ...currentFilters,
      [title]: value,
    });
  };

  const onFiltersClear = () => {
    setCurrentFilters(generateDefaultFiltersFromFilterOptions(filterOptions));
  };

  return {
    filterOptions,
    currentFilters,
    onFiltersChange,
    onFiltersClear,
    countryFilter,
    setCountryFilter,
  };
};

export default useReportingMapFilters;

const generateFilterOptionsFromSidebarProps = (
  props: SidebarProps
): FilterOptionProps[] => {
  let result = [] as FilterOptionProps[];
  result = [
    generateDateRangeFilterOptions(props.defaultDateRange),
    {
      title: "KPI Type",
      defaultDropdownOption: props.defaultDropdownKey,
      dropdownOptions: props.availableTypes,
    },
  ];
  return result;
};

const generateDateRangeFilterOptions = (
  defaultRange?: string
): FilterOptionProps => {
  return {
    title: "Date Range",
    defaultDropdownOption: defaultRange ?? "Last 7 Days",
    dropdownOptions: [
      "Last 7 Days",
      "Last 30 Days",
      "Last 12 Weeks",
      "Last 12 Months",
      "Year To Date",
      "All Time",
    ],
  };
};

const generateDefaultFiltersFromFilterOptions = (
  filterOptions: FilterOptionProps[]
) => {
  let filters = {} as MapSidebarFiltersProps["currentFilters"];
  for (let option of filterOptions) {
    filters[option.title] = option.defaultDropdownOption;
  }
  return filters;
};
